// extracted by mini-css-extract-plugin
export default {"alert":"Alert_alert__FTQPH","dense":"Alert_dense__JMXQe"};